/**
 * DEV-ONLY: Shared stack for devtools panels. Panels register here to appear stacked top-right.
 */
import React, { createContext, useContext, useRef, useState, useCallback, useMemo } from "react";
import "./DevtoolsPanels.css";

const DevtoolsStackContext = createContext(null);

const PANEL_ORDER = ["overlay", "inspector"];

export function DevtoolsStackProvider({ children }) {
  const panelsRef = useRef({});
  const [, setTick] = useState(0);

  const registerPanel = useCallback((key, renderFn) => {
    panelsRef.current[key] = renderFn;
    setTick((c) => c + 1);
  }, []);

  const unregisterPanel = useCallback((key) => {
    delete panelsRef.current[key];
    setTick((c) => c + 1);
  }, []);

  const value = useMemo(
    () => ({
      registerPanel,
      unregisterPanel,
    }),
    [registerPanel, unregisterPanel]
  );
  const panels = panelsRef.current;
  const hasAny = PANEL_ORDER.some((k) => panels[k]);

  return (
    <DevtoolsStackContext.Provider value={value}>
      {children}
      {hasAny && (
        <div className="devtools-stack" aria-label="Dev tools panels">
          {PANEL_ORDER.filter((k) => panels[k]).map((k) => {
            const fn = panels[k];
            return typeof fn === "function" ? <React.Fragment key={k}>{fn()}</React.Fragment> : null;
          })}
        </div>
      )}
    </DevtoolsStackContext.Provider>
  );
}

export function useDevtoolsStack() {
  return useContext(DevtoolsStackContext);
}
